module.exports = __webpack_public_path__ + "img/AL273HS-1-EN.d1e9fd18.jpg";